import { api } from '../apiClient'

export interface BlogListItem {
  slug: string
  title: string
  excerpt: string
  category: string
  tags: string[]
  heroImageUrl?: string
  heroThumbUrl?: string
  heroGradient: string
  readingMinutes: number
  author: string
  publishedAt: string
  updatedAt: string
}

export interface BlogFaq { q: string; a: string }

export interface BlogPostFull extends BlogListItem {
  metaTitle?: string
  metaDescription: string
  bodyHtml: string
  keywords: string[]
  faqs: BlogFaq[]
  relatedSlugs: string[]
}

export interface BlogListResponse {
  posts: BlogListItem[]
  total: number
  page: number
  limit: number
  hasMore: boolean
  categories: string[]
}

export async function fetchBlogList(params?: { page?: number; category?: string; limit?: number }): Promise<BlogListResponse> {
  const res = await api.get('/api/blog', { params })
  return res.data as BlogListResponse
}

export async function fetchBlogPost(slug: string): Promise<{ post: BlogPostFull; related: BlogListItem[] }> {
  const res = await api.get(`/api/blog/${encodeURIComponent(slug)}`)
  return res.data as { post: BlogPostFull; related: BlogListItem[] }
}
